import { ButtonPseudo, IconExpand } from '@ui/src';
import Hint from '../../common/hint/hint';
import { HeaderTypes } from './types';

import cn from './styles.module.css';

const Header = ({ onClick }: HeaderTypes): React.JSX.Element => (
  <div className={cn.header}>
    <div className={cn.title}>Employees Roles</div>
    <div className={cn.descriptionWrapper}>
      <div className={cn.description}>
        All users have basic access, regardless of role
      </div>
      <Hint>
        <ul>
          <li>Dashboard view</li>
          <li>Accounts view</li>
          <li>Customers view</li>
          <li>AML & KYC view</li>
          <li>Transactions view</li>
          <li>Cards view</li>
          <li>Reports view</li>
          <li>Banks view</li>
          <li>Fees & Tariffs view</li>
          <li>Administration view</li>
        </ul>
      </Hint>
    </div>
    {onClick && (
      <ButtonPseudo
        text="Add role"
        onClick={onClick}
        bold
        icon={<IconExpand />}
        className={cn.addButton}
      />
    )}
  </div>
);

export default Header;
